import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { type PressableProps } from 'react-native';

import { messages } from '../messages';
import { NavbarTextLinkCta } from './NavbarTextLinkCta';

export const NavbarGiftCta = (props: Props) => {
  const { onPress } = props;

  const { formatMessage } = useIntl();

  return (
    <NavbarTextLinkCta
      testID="nav-bar.gift"
      aria-label={formatMessage(messages.giftA11y)}
      onPress={onPress}
    >
      <FormattedMessage {...messages.gift} />
    </NavbarTextLinkCta>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Pick<PressableProps, 'onPress'>;
